import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
    border: none;
    border-radius: 5px;
    min-width: 300px;
    padding: 20px 35px;
    margin: 20px auto;
    font-size: 24px;
    background-color: ${ props => ( props.isActive ? '#00b894' : props.color ) };
    color: #fff;
    cursor: pointer;
    z-index: 1;

    :first-of-type {
        margin-top: 0;
    }

    :last-of-type {
        margin-bottom: 0;
    }

    :focus {
        outline: 0;
    }

    @media screen and (min-width: 650px) {
        margin: 20px 0;

        :first-of-type {
            margin-top: 20px;
        }
    
        :last-of-type {
            margin-bottom: 20px;
        }
    }
`

class TaskButton extends React.Component {

    render(){
        return(
            <Button id={this.props.id} color={this.props.task.color} isActive={this.props.task.isActive} onClick={this.props.startTimer}>
                {this.props.task.title}
            </Button>
        )
    }
}

export default TaskButton;


// WEBPACK FOOTER //
// ./src/components/TaskButton.js